import { Phone, Mail, MessageCircle } from 'lucide-react';
import './ContactInfo.css';

export default function ContactInfo({ layout = 'inline', theme = 'light' }) {
  const contactDetails = [
    {
      icon: <Phone size={18} />,
      label: 'Phone',
      value: '+91 9136 663456',
      href: 'tel:+919136663456',
      alt: 'Call us'
    },
    {
      icon: <MessageCircle size={18} />,
      label: 'WhatsApp & Mobile',
      value: '+91 9967 765284',
      href: 'https://wa.me/919967765284',
      alt: 'WhatsApp us'
    },
    {
      icon: <Mail size={18} />,
      label: 'Email',
      value: 'onlineworldwide11@gmail.com',
      href: 'mailto:onlineworldwide11@gmail.com',
      alt: 'Email us'
    },
  ];

  if (layout === 'inline') {
    return (
      <div className={`contact-info contact-info--inline contact-info--${theme}`}>
        {contactDetails.map((detail) => (
          <a
            key={detail.label}
            href={detail.href}
            className="contact-info__item"
            title={detail.alt}
          >
            <span className="contact-info__icon">{detail.icon}</span>
            <div className="contact-info__text">
              <div className="contact-info__label">{detail.label}</div>
              <div className="contact-info__value">{detail.value}</div>
            </div>
          </a>
        ))}
      </div>
    );
  }

  if (layout === 'card') {
    return (
      <div className={`contact-info-card contact-info-card--${theme}`}>
        <h3 className="contact-info-card__title">📞 Get in Touch</h3>
        <p className="contact-info-card__subtitle">
          We're available 24/7 to assist you. Respond within 2–4 hours.
        </p>
        <div className="contact-info-card__items">
          {contactDetails.map((detail) => (
            <a
              key={detail.label}
              href={detail.href}
              className="contact-info-card__item"
              title={detail.alt}
            >
              <span className="contact-info-card__icon">{detail.icon}</span>
              <div className="contact-info-card__text">
                <div className="contact-info-card__label">{detail.label}</div>
                <div className="contact-info-card__value">{detail.value}</div>
              </div>
              <span className="contact-info-card__arrow">→</span>
            </a>
          ))}
        </div>
      </div>
    );
  }

  if (layout === 'compact') {
    return (
      <div className={`contact-info-compact contact-info-compact--${theme}`}>
        {contactDetails.map((detail, idx) => (
          <a
            key={detail.label}
            href={detail.href}
            className="contact-info-compact__item"
            title={detail.alt}
          >
            {detail.icon}
            <span>{detail.value}</span>
            {idx < contactDetails.length - 1 && <span className="contact-info-compact__divider">·</span>}
          </a>
        ))}
      </div>
    );
  }

  return null;
}

